export const USER_KPIS = ['active_users', 'registered_users'] as const;

export const DELIVERY_NOTE_KPIS = [
  'total_dlns',
  'assigned_dlns',
  'signed_dlns',
] as const;

export const ANALYTICS_KPIS = [...USER_KPIS, ...DELIVERY_NOTE_KPIS] as const;
